import {
  newGetFieldLabel,
  newGetFieldPlaceholder, newGetInitialValues,
  newIsFieldRequired, newValidate, Translation as T, useAmsSelector
} from "@awe-web/shared/lib";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormikLabeledField,
  FormikPasswordInput,
  FormikTextInput,
  RequiredNotice,
  ScrollToError
} from "../../components/form.js";
import { submit } from "./actions.js";

import "./reset_password_entry_form.scss";

const SUBMIT = "FSD0000352";
const NOTICE = "FSD0000209";

function InternalResetPasswordForm({ handleSubmit }) {

  const isFieldRequired = useAmsSelector((state) => newIsFieldRequired("resetPassword")(state));
  const getFieldLabel = useAmsSelector((state) => newGetFieldLabel("resetPassword")(state));
  const getFieldPlaceholder = useAmsSelector((state) => newGetFieldPlaceholder("resetPassword")(state));

  return (
    <form
      className="reset-password-entry-form"
      onSubmit={handleSubmit}
    >
      <ScrollToError />
      <FormikLabeledField
        className="reset-password-entry-form__username"
        name="username"
        as={FormikTextInput}
        getFieldLabel={getFieldLabel}
        isFieldRequired={isFieldRequired}
        placeholder={getFieldPlaceholder("username")}
      />

      <FormikLabeledField
        className="reset-password-entry-form__password"
        name="password"
        as={FormikPasswordInput}
        getFieldLabel={getFieldLabel}
        isFieldRequired={isFieldRequired}
        placeholder={getFieldPlaceholder("password")}
      />

      <Button primary continue submit className="reset-password-entry-form__submit-button">
        <T code={SUBMIT} />
      </Button>

      <RequiredNotice><T code={NOTICE} /></RequiredNotice>
    </form>
  );
}

InternalResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired
};

export default function ResetPasswordEntryForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validate = useAmsSelector((state) => newValidate("resetPassword")(state));

  const initialValues = useAmsSelector((state) => {
    const formInitializer = newGetInitialValues("resetPassword");
    const inialValuesFactory = formInitializer(state);
    return inialValuesFactory({
      username: "",
      password: ""
    });
  });

  const onSubmit = useCallback(async (values, formikProps) => {
    const nextPath = await dispatch(submit(values, formikProps));
    if (nextPath && nextPath.length > 0) {
      navigate(nextPath);
    }
  }, [dispatch, navigate]);

  return (
    <Formik initialValues={initialValues} validate={validate} onSubmit={onSubmit}>
      {(formikProps) => (
        <InternalResetPasswordForm {...formikProps} />
      )}
    </Formik>
  );
}
